var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.779,
    height: 67.209,
    viewBox: "0 0 65.779 67.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11028",
    x: 0,
    y: 0,
    width: 55.853,
    height: 67.209,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_11028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11028-2",
    "data-name": "Path 11028",
    d: "M2,2H39.853V51.209H2Z",
    transform: "translate(7 4)",
    fill: "#c7e2fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11029",
    "data-name": "Path 11029",
    d: "M2,41.733c.158,0,.314.012.473.012A32.887,32.887,0,0,0,35.121,8.624,33.782,33.782,0,0,0,34.467,2H2Z",
    transform: "translate(-2 -2)",
    fill: "#ebf7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11030",
    "data-name": "Path 11030",
    d: "M36,28H54.926V43.141H36Z",
    transform: "translate(-3.825 -3.396)",
    fill: "#c18e5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11031",
    "data-name": "Path 11031",
    d: "M36,28V40.191a17.342,17.342,0,0,0,1.893.111A17.029,17.029,0,0,0,54.246,28Z",
    transform: "translate(-3.825 -3.396)",
    fill: "#cda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11032",
    "data-name": "Path 11032",
    d: "M40,44H60.819V61.034H40Z",
    transform: "translate(-4.04 -4.254)",
    fill: "#c18e5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11033",
    "data-name": "Path 11033",
    d: "M40,58.141C48.405,57.566,55.539,51.925,58.845,44H40Z",
    transform: "translate(-4.04 -4.254)",
    fill: "#cda57d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9358",
    "data-name": "Group 9358",
    transform: "translate(3.785 3.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11034",
    "data-name": "Path 11034",
    d: "M6,6h7.571v7.571H6Z",
    transform: "translate(-6 -6)",
    fill: "#4472b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11035",
    "data-name": "Path 11035",
    d: "M6,18h7.571v7.571H6Z",
    transform: "translate(-6 -6.644)",
    fill: "#4472b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11036",
    "data-name": "Path 11036",
    d: "M6,30h7.571v7.571H6Z",
    transform: "translate(-6 -7.288)",
    fill: "#4472b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11037",
    "data-name": "Path 11037",
    d: "M6,42h7.571v7.571H6Z",
    transform: "translate(-6 -7.932)",
    fill: "#4472b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9359",
    "data-name": "Group 9359",
    transform: "translate(14.195 4.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11038",
    "data-name": "Path 11038",
    d: "M17,7H37.819V8.893H17Z",
    transform: "translate(-17 -7)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9360",
    "data-name": "Group 9360",
    transform: "translate(14.195 8.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11039",
    "data-name": "Path 11039",
    d: "M17,11H37.819v1.893H17Z",
    transform: "translate(-17 -11)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9361",
    "data-name": "Group 9361",
    transform: "translate(14.195 16.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11040",
    "data-name": "Path 11040",
    d: "M17,19H37.819v1.893H17Z",
    transform: "translate(-17 -19)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9362",
    "data-name": "Group 9362",
    transform: "translate(14.195 19.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11041",
    "data-name": "Path 11041",
    d: "M17,23H37.819v1.893H17Z",
    transform: "translate(-17 -23)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9363",
    "data-name": "Group 9363",
    transform: "translate(14.195 27.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11042",
    "data-name": "Path 11042",
    d: "M17,31H34.98v1.893H17Z",
    transform: "translate(-17 -31)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9364",
    "data-name": "Group 9364",
    transform: "translate(14.195 31.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11043",
    "data-name": "Path 11043",
    d: "M17,35H34.98v1.893H17Z",
    transform: "translate(-17 -35)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9365",
    "data-name": "Group 9365",
    transform: "translate(5.007 1.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11044",
    "data-name": "Path 11044",
    d: "M0,0H10.707V1.893H0Z",
    transform: "translate(0 7.57) rotate(-45)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9366",
    "data-name": "Group 9366",
    transform: "translate(5.005 23.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11045",
    "data-name": "Path 11045",
    d: "M0,0H10.707V1.893H0Z",
    transform: "translate(0 7.57) rotate(-45)",
    fill: "#c1c8d1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11046",
    "data-name": "Path 11046",
    d: "M48,44h5.678v5.678H48Z",
    transform: "translate(-4.469 -4.254)",
    fill: "#e1c9b1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9367",
    "data-name": "Group 9367",
    transform: "translate(50.155 52.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11047",
    "data-name": "Path 11047",
    d: "M55,57h3.785v1.893H55Z",
    transform: "translate(-55 -57)",
    fill: "#e1c9b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9368",
    "data-name": "Group 9368",
    transform: "translate(44.477 35.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    d: "M49,39h3.785v1.893H49Z",
    transform: "translate(-49 -39)",
    fill: "#e1c9b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9369",
    "data-name": "Group 9369",
    transform: "translate(50.155 48.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11049",
    "data-name": "Path 11049",
    d: "M55,53h3.785v1.893H55Z",
    transform: "translate(-55 -53)",
    fill: "#e1c9b1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11050",
    "data-name": "Path 11050",
    d: "M18,44H38.819V61.034H18Z",
    transform: "translate(-2.859 -4.254)",
    fill: "#c18e5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11051",
    "data-name": "Path 11051",
    d: "M18,58.141C26.405,57.566,33.539,51.925,36.845,44H18Z",
    transform: "translate(-2.859 -4.254)",
    fill: "#cda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11052",
    "data-name": "Path 11052",
    d: "M26,44h5.678v5.678H26Z",
    transform: "translate(-3.288 -4.254)",
    fill: "#e1c9b1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9370",
    "data-name": "Group 9370",
    transform: "translate(29.336 52.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11053",
    "data-name": "Path 11053",
    d: "M33,57h3.785v1.893H33Z",
    transform: "translate(-33 -57)",
    fill: "#e1c9b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9371",
    "data-name": "Group 9371",
    transform: "translate(29.336 48.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11054",
    "data-name": "Path 11054",
    d: "M33,53h3.785v1.893H33Z",
    transform: "translate(-33 -53)",
    fill: "#e1c9b1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    d: "M44,28h3.785v5.678H44Z",
    transform: "translate(-4.254 -3.396)",
    fill: "#e1c9b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoIcon);
export default __webpack_public_path__ + "static/media/Po-icon.84a206a32e5a7863fd3e223a900ac836.svg";
export { ForwardRef as ReactComponent };